import type { FunctionComponent, ReactNode, MouseEventHandler } from 'react'
import styled from 'styled-components'
import usePassPropsToChildren from './hooks/usePassPropsToChildren'

export enum Position {
  Left = 'left',
  Right = 'right',
}

const StyledLabel = styled.label<{ $disabled?: boolean; $position?: Position }>`
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
  width: 100%;
  color: var(--dark);
  text-align: ${(props) => (props?.$position === Position.Left ? 'left' : 'right')};
  opacity: ${(props) => (props?.$disabled ? 0.3 : 1)};

  &:has(input[type='checkbox']:checked) {
    font-weight: 700;
  }
`

const StyledSpan = styled.span<{ position?: Position }>`
  margin: 0.5rem 0;
  width: 100%;
  text-align: ${(props) => (props?.position === Position.Left ? 'left' : 'right')};
`

interface LabelProps {
  children?: ReactNode
  disabled?: boolean
  htmlFor?: string
  label: string
  onClick?: MouseEventHandler
  position?: Position
}

const Label: FunctionComponent<LabelProps> = ({
  children: childrenProps,
  disabled,
  htmlFor,
  label,
  onClick,
  position,
  ...otherProps
}) => {
  const { children } = usePassPropsToChildren(childrenProps, {
    disabled,
  })
  return (
    <StyledLabel
      $disabled={disabled}
      htmlFor={htmlFor}
      $position={position}
      onClick={onClick}
      {...otherProps}
    >
      {children}
      <StyledSpan position={position}>{label}</StyledSpan>
    </StyledLabel>
  )
}

export default Label
